<template>
    <div class="grapejs">
        <div class="container-holder">
            <div id="gjs"></div>
        </div>
    </div>
</template>
<style lang="scss">
.grapejs {
    position: fixed;
    z-index: 99;
    width: 100%;
    height: 100%;
    background: #fff;
    left: 0;
    top: 0;
}
/* Let's highlight canvas boundaries */
.container-holder {
    width: 100%;
    height: 100%;
}
</style>
<script>
import keviApi from "../../keviApi";
import pt from "grapesjs/locale/pt.js";

// import html from './templates/empty.html'
// import css from './templates/empty.js'
export default {
    name: "grapejs",
    props: {
        tokens: {
            type: Array,
            default: () => [],
        },
        emailId: {
            type: String,
            default: "",
        },
        html: {
            type: String,
            default: "",
        },
    },
    data: () => ({
        stripo: null,
    }),
    async mounted() {
        this.initialize();
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        initialize() {
            pt.blockManager = {
                labels: {
                    sect100: this.t("grapejs-blocks-sect100"),
                    sect50: this.t("grapejs-blocks-sect50"),
                    sect30: this.t("grapejs-blocks-sect30"),
                    sect37: this.t("grapejs-blocks-sect37"),
                    button: this.t("grapejs-blocks-button"),
                    divider: this.t("grapejs-blocks-divider"),
                    text: this.t("grapejs-blocks-text"),
                    "text-sect": this.t("grapejs-blocks-text-sect"),
                    image: this.t("grapejs-blocks-image"),
                    quote: this.t("grapejs-blocks-quote"),
                    "grid-items": this.t("grapejs-blocks-grid_items"),
                    "list-items": this.t("grapejs-blocks-list_items"),
                    link: this.t("grapejs-blocks-link"),
                    "link-block": this.t("grapejs-blocks-link_block"),
                },
            };

            const editor = grapesjs.init({
                // Indicate where to init the editor. You can also pass an HTMLElement
                container: "#gjs",
                // Get the content for the canvas directly from the element
                // As an alternative we could use: `components: '<h1>Hello World Component!</h1>'`,
                components: this.html,
                width: "100%",
                height: "100%",
                plugins: ["grapesjs-preset-newsletter"],
                i18n: {
                    locale: "pt", // default locale
                    detectLocale: false,
                    messages: { pt },
                },
                pluginsOpts: {
                    "grapesjs-preset-newsletter": {
                        // options
                    },
                },
                // Disable the storage manager for the moment
                storageManager: false,
                assetManager: {
                    headers: keviApi.getAuthHeader(),
                    // Upload endpoint, set `false` to disable upload, default `false`
                    upload: keviApi.endpoint + "/storage/upload",
                    // The name used in POST to pass uploaded files, default: `'files'`
                    uploadName: "files",
                    credentials: "omit",
                    assets: [],
                },
            });

            const options = keviApi.getOptions("files-gallery");
            options.params = {
                "filters[file-type]": "image",
            };
            this.$http(options).then(response => {
                const images = Object.values(response.data.files);

                images.forEach(image => {
                    editor.AssetManager.add({
                        src: image.url,
                        name: image.storage_location,
                    });
                });
            });

            editor.on("styleable:change", (model, property) => {
                const value = model.getStyle()[property];
                if (value === undefined || value.indexOf("!important") === -1) {
                    return;
                } else {
                    const regex = /\!important/g;
                    const matches = value.match(regex);
                    if (matches.length > 1) {
                        const newValue =
                            value.split("!important").join("") + " !important";
                        model.addStyle({ [property]: newValue });
                    }
                }
            });

            editor.Commands.add("saveEmail", {
                run: (editor, sender) => {
                    console.log(
                        editor.Commands.get("gjs-get-inlined-html").run(
                            editor,
                            sender,
                        ),
                    );
                    this.$emit(
                        "saveEmail",
                        editor.Commands.get("gjs-get-inlined-html").run(
                            editor,
                            sender,
                        ),
                    );
                },
            });
            editor.Commands.add("cancelEmail", {
                run: (editor, sender) => {
                    this.$emit("cancelEmail");
                },
            });
            editor.Panels.addButton("devices-c", {
                id: "save",
                className: "save template btn btn-primary",
                command: "saveEmail",
                attributes: { title: this.t("grapejs-save_email"), style: "order: -2" },
                label: this.t("grapejs-save"),
                active: false,
            });

            editor.Panels.addButton("devices-c", {
                id: "cancel",
                className: "save template btn btn-text",
                command: "cancelEmail",
                attributes: {
                    title: this.t("grapejs-cancel"),
                    style: "order: -1; color: #fff; font-size: 12px",
                },
                label: this.t("grapejs-cancel"),
                active: false,
            });
            const iconStyle = 'style="display: block; max-width: 22px"';
            let editPanel = null;
            const tokens = this.tokens.join("<br />");
            const tokensTitle = this.t("grapejs-tokens");
            editor.Panels.addButton("views", {
                id: "editMenu",
                attributes: {
                    class: "fa fa-address-card-o",
                    title: this.t("grapejs-edit_menu"),
                },
                active: false,
                command: {
                    run: function (editor) {
                        if (editPanel == null) {
                            const editMenuDiv = document.createElement("div");
                            editMenuDiv.innerHTML = `
                        <div id="your-content" style="padding: 20px 10px; text-align: left;">
                             <span style="font-weight: 600; display: inline-block; margin-bottom: 5px;">${tokensTitle}</span> <br />
                             ${tokens}
                        </div>
                    `;
                            const panels =
                                editor.Panels.getPanel("views-container");
                            panels
                                .set("appendContent", editMenuDiv)
                                .trigger("change:appendContent");
                            editPanel = editMenuDiv;
                        }
                        editPanel.style.display = "block";
                    },
                    stop: function (editor) {
                        if (editPanel != null) {
                            editPanel.style.display = "none";
                        }
                    },
                },
            });
        },
    },
};
</script>
